import type { Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import getComponentDescriptionsByName from '../../dolan/utils/getComponentDescriptionsByName';
import autoGenerateDolanLogicFlowsForView from './autoGenerateDolanLogicFlowsForView';

/**
 * Performs auto-generation and cleanup of all the logic in DOLAN,
 * for each view.
 */
export default function autoGenerateDolanLogicFlows(dolan: Dolan): Dolan {
  const descriptions = getComponentDescriptionsByName(dolan);
  const dataResources = dolan.data_resources;
  let changed = false;
  const newViews = dolan.views.map((view) => {
    const newView = autoGenerateDolanLogicFlowsForView(view, descriptions, dataResources);
    if (newView !== view) {
      changed = true;
    }
    return newView;
  });
  return changed ? { ...dolan, views: newViews } : dolan;
}
